import React from 'react';
import { Star } from 'lucide-react';
export function ProBonuses() {
  const proBonuses = [{
    id: '01',
    icon: '🤖',
    title: 'Prompts de IA para Renders',
    value: '$12.000',
    desc: 'Prompts listos para generar renders realistas de la decoración antes de armarla.',
    for: 'Para mostrarle al cliente cómo va a quedar antes de comprar un solo globo — y para vos, para no gastar de más en algo que no cierra.'
  }, {
    id: '02',
    icon: '📝',
    title: 'Plantillas de Contratos y Señas',
    value: '$9.000',
    desc: 'Contratos simples y recibos de seña listos para usar.',
    for: 'Para que te tomen en serio como profesional, cobres seña con tranquilidad y evites que te cancelen a último momento.'
  }, {
    id: '03',
    icon: '🎓',
    title: 'Masterclass "De Hobby a Negocio"',
    value: '$11.000',
    desc: 'Cómo poner precio a tu trabajo, presentarte como profesional y conseguir tus primeros clientes pagos.',
    for: 'Para dar el salto real de "la que decora gratis para las amigas" a "la profesional que cobra por su trabajo" — con casos reales de mujeres que ya lo hicieron.'
  }];
  return <section className="py-16 px-5 bg-wine text-white" data-id="element-199">
      <div className="max-w-md mx-auto" data-id="element-200">
        <div className="flex justify-center mb-4" data-id="element-201">
          <span className="bg-gold text-wine px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider flex items-center gap-1 shadow-md" data-id="element-202">
            <Star className="w-3.5 h-3.5 fill-wine" data-id="element-203" /> Exclusivo del Plan
            PRO/Élite
          </span>
        </div>
        <h2 className="text-3xl font-bold text-center mb-3" data-id="element-204">
          De hobby a negocio. Con las herramientas de una profesional.
        </h2>
        <p className="text-center text-white/80 mb-10 text-[15px]" data-id="element-205">
          Solo para quienes eligen el Plan PRO/Élite.
        </p>

        <div className="flex flex-col gap-4" data-id="element-206">
          {proBonuses.map(bono => <div key={bono.id} className="bg-gradient-to-br from-white/10 to-transparent border border-gold/30 rounded-2xl p-5 relative overflow-hidden" data-id="element-207">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gold/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-208"></div>

              <div className="flex justify-between items-start mb-3 relative z-10" data-id="element-209">
                <div className="flex items-center gap-3" data-id="element-210">
                  <span className="text-3xl" data-id="element-211">{bono.icon}</span>
                  <div data-id="element-212">
                    <div className="text-xs font-bold text-gold uppercase tracking-wider mb-0.5" data-id="element-213">
                      Bono PRO {bono.id}
                    </div>
                    <div className="font-bold text-lg leading-tight" data-id="element-214">
                      {bono.title}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-2 mb-4 relative z-10" data-id="element-215">
                <span className="line-through text-white/50 text-sm" data-id="element-216">
                  {bono.value}
                </span>
                <span className="bg-gold/20 text-gold border border-gold/30 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-217">
                  INCLUIDO
                </span>
              </div>

              <p className="font-medium text-[15px] mb-4 relative z-10" data-id="element-218">
                {bono.desc}
              </p>

              <div className="bg-black/20 p-3.5 rounded-xl text-sm text-white/90 relative z-10 border border-white/5" data-id="element-219">
                <span className="font-bold text-gold" data-id="element-220">Para qué sirve:</span>{' '}
                {bono.for}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}